import logo from './logo.svg';
import { BrowserRouter } from 'react-router-dom';
import Publicroutes from './Routes/Publicroutes';
import "../src/assets/Css/style.css";
import "../src/assets/Css/about.css"

function App() {
  return (
<>
<Publicroutes />
</>
  );
}

export default App;
